import { useState } from "react";
import { Button } from "react-bootstrap";
import ausloggen from "./img/ausloggen.png";
import { useEffect } from "react";

export default function Bearbeitungsanfrage({ showAnfrage, setShowAnfrage }) {
   /* 
   Sperren indem loading gesetzt wird.
   Ist die Seite einmal blockiert, bleibt sie blockiert.
   wird eine Seite neu geladen, die offen ist, wird loading gesetzt.
   */
   useEffect(() => {
      let anfrageTimer = setTimeout(() => {}, 10000);
   }, []);

   function handleClose() {
      setShowAnfrage(false);
   }

   return (
      <div className="bearbeitungsanfrage">
         <div >
            <h2>{showAnfrage.name} möchte gerne das Objekt bearbeiten</h2>
            <Button onClick={handleClose}>Ignorieren</Button>
            {/*<h2>Bearbeitungsanfrage von {showAnfrage.name}!</h2>
             <p> Wenn die Anfrage nicht in <strong style={{fontSize: "xx-large", margin: "0 10px"}}>5 </strong> Sekunden abgelehnt wird, wird der aktuelle Stand gespeichert und das Speichern wird gesperrt.</p>
            <p> Die Sperre lässt sich nur durch aktualisieren der Website und anfragen des Zugriffs lösen</p>
            <Button variant="primary" onClick={handleClose}>
               Ablehnen
            </Button> */}
         </div>
      </div>
   );
}
